import { addMatchedMentor } from '../api/surgeon_referred_mentor_matches';

export const findAndSetMentor = (callbacks = {}, context) => {
  const { onMentorFound, onSetPatientPartner } = callbacks;

  const timer = setTimeout(() => {
    addMatchedMentor((data) => {
      context.auth.userUpdate({ matched_with_mentor: true }, () => {});

      if (onSetPatientPartner) {
        onSetPatientPartner(data);
        sessionStorage.setItem('patientPartner', JSON.stringify(data));
      }

      if (onMentorFound) {
        onMentorFound(true);
      }
    });
  }, 3000);
  return () => clearTimeout(timer);
};
